
// 判断当前页面拥有的按钮 返回值 true--显示  false--隐藏
import qs from 'qs'
export default (routeName, val_) => {
  const btnsArr = qs.parse(sessionStorage.btns) // 当前用户没有的权限按钮
  if (btnsArr.hasOwnProperty(routeName)) { // 判断传入的页面name是否在数组之中
    if (btnsArr[routeName].indexOf(val_) !== -1) { // 判断当前按钮是否存在于数组中
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/api/btnAuth.js